import React from "react"
import { Link } from "react-router-dom";

import { routes } from "../../constants/routes";


const containerStyles = {
    //height: '600px'
    height: "100vh"
};

const cardStyles = {
    minWidth: "40vw"
};

/**
 * Komponent reprezetujacy strone nieodlalezioną
 */
const NotFoundPage = () => {
    return (
        <div className="w3-display-container" style={containerStyles}>
            <div className="w3-card-4 w3-display-middle" style={cardStyles}>
                <div className="w3-container w3-theme">
                    <h1 className="w3-center">
                        404
                    </h1>
                </div>
                <div className="w3-padding">Nie znaleziono strony o podanym adresie</div>
                <div className="w3-padding">Prawdopodobnie została skasowana, zmieniono jej nazwę albo została czasowo usunięta.
Sprawdź poprawność adresu lub przejdź do strony głównej</div>
                <footer className="w3-container w3-theme-dark">
                    <div className="w3-bar">
                        <Link to={routes.HOME} className="w3-bar-item w3-right w3-small w3-btn">Wróc do głównej strony</Link>
                    </div>
                </footer>
            </div>

        </div>
    )
}

export default NotFoundPage